import {
  Calendar,
  CircleDot,
  Clock,
  Euro,
  FileText,
  Hash,
  Hourglass,
  MapPin,
  Phone,
  Route,
  Truck,
  User,
  type LucideIcon,
} from 'lucide-react'

/**
 * Trazabis DS: cada cabecera de tabla lleva un icono lila de 13 px que dice
 * que clase de dato hay debajo. El mapeo sigue la tabla canonica de la suite
 * (mismo concepto, mismo icono en todos los aplicativos) y va por el texto de
 * la cabecera, asi ninguna columna tiene que declararlo. Una cabecera que no
 * esta aqui sale sin icono, que es mejor que con uno equivocado.
 */
const ICONOS: Record<string, LucideIcon> = {
  nombre: User,
  cliente: User,
  movil: Phone,
  telefono: Phone,
  direccion: MapPin,
  poblacion: MapPin,
  'c.p.': MapPin,
  estado: CircleDot,
  'semanas sin pedir': Hourglass,
  aplazamientos: Clock,
  'ultimo albaran': FileText,
  'ultimo aviso': Calendar,
  'ultima vez': Calendar,
  nif: Hash,
  'ficha del cliente': FileText,
  pedido: FileText,
  linea: Hash,
  'dia de ruta': Route,
  reparto: Truck,
  'total catalogo': Euro,
}

const sinAcentos = (texto: string) => texto.normalize('NFD').replace(/[̀-ͯ]/g, '')

export function iconoDeColumna(cabecera: unknown): LucideIcon | null {
  if (typeof cabecera !== 'string') return null
  return ICONOS[sinAcentos(cabecera).trim().toLowerCase()] ?? null
}
